import { BaseService } from "../../core/baseService";
import { StatisticsServiceInterface } from "../types/statistics.types";
import { OrderStatistics } from "../../../models";
import {
  DashboardSummary,
  RevenueStatistics,
  OccupancyStatistics,
  ServiceStatistics,
  GuestStatistics,
  OperationalStatistics,
  ComparativeStatistics,
  StatisticsFilter,
} from "../types/expandedStatistics.types";

export class StatisticsService
  extends BaseService
  implements StatisticsServiceInterface
{
  // Original Order Statistics
  async getOrdersPerDayOfWeek() {
    return this.handleRequest<OrderStatistics>(
      this.client.get("/api/admin/statistics/orders/by-day-of-week"),
    );
  }

  async getOrdersPerMonth() {
    return this.handleRequest<OrderStatistics>(
      this.client.get("/api/admin/statistics/orders/by-month"),
    );
  }

  // Original Service Request Statistics
  async getServiceRequestsPerDayOfWeek() {
    return this.handleRequest<OrderStatistics>(
      this.client.get("/api/admin/statistics/servicerequests/by-day-of-week"),
    );
  }

  async getServiceRequestsPerMonth() {
    return this.handleRequest<OrderStatistics>(
      this.client.get("/api/admin/statistics/servicerequests/by-month"),
    );
  }

  // New Expanded Statistics Methods
  async getDashboardSummary() {
    return this.handleRequest<DashboardSummary>(
      this.client.get("/api/admin/statistics/dashboard"),
    );
  }

  async getRevenueStatistics(filter?: StatisticsFilter) {
    return this.handleRequest<RevenueStatistics>(
      this.client.get("/api/admin/statistics/revenue", { params: filter }),
    );
  }

  async getOccupancyStatistics(filter?: StatisticsFilter) {
    return this.handleRequest<OccupancyStatistics>(
      this.client.get("/api/admin/statistics/occupancy", { params: filter }),
    );
  }

  async getServiceStatistics(filter?: StatisticsFilter) {
    return this.handleRequest<ServiceStatistics>(
      this.client.get("/api/admin/statistics/services", { params: filter }),
    );
  }

  async getGuestStatistics(filter?: StatisticsFilter) {
    return this.handleRequest<GuestStatistics>(
      this.client.get("/api/admin/statistics/guests", { params: filter }),
    );
  }

  async getOperationalStatistics(filter?: StatisticsFilter) {
    return this.handleRequest<OperationalStatistics>(
      this.client.get("/api/admin/statistics/operations", { params: filter }),
    );
  }

  async getComparativeStatistics(period1: string, period2: string) {
    return this.handleRequest<ComparativeStatistics>(
      this.client.get("/api/admin/statistics/compare", {
        params: { period1, period2 },
      }),
    );
  }
}
